export const dummyDataBreakdownDataQuality = [
  {
    label: 'Spend Data',
    value: 45
  },
  {
    label: 'Average Data',
    value: 68
  },
  {
    label: 'Actual Data',
    value: 103
  },
]

export const dummyDataGhgBreakdown = [
  { label: 'CO2', totalEmission: 14.85 },
  { label: 'CH4', totalEmission: 3.13 },
  { label: 'N2O', totalEmission: 1.18 }
];

export const dummyDataStackedScope = [
  { month: 'Jan-25', 'Scope 1': 0.28, 'Scope 2': 0.37, 'Scope 3': 0.93 },
  { month: 'Feb-25', 'Scope 1': 0.27, 'Scope 2': 0.36, 'Scope 3': 0.89 },
  { month: 'Mar-25', 'Scope 1': 0.29, 'Scope 2': 0.39, 'Scope 3': 0.95 },
  { month: 'Apr-25', 'Scope 1': 0.26, 'Scope 2': 0.33, 'Scope 3': 0.85 },
  { month: 'May-25', 'Scope 1': 0.30, 'Scope 2': 0.41, 'Scope 3': 0.98 },
  { month: 'Jun-25', 'Scope 1': 0.31, 'Scope 2': 0.43, 'Scope 3': 1.02 },
  { month: 'Jul-25', 'Scope 1': 0.32, 'Scope 2': 0.45, 'Scope 3': 1.06 },
  { month: 'Aug-25', 'Scope 1': 0.30, 'Scope 2': 0.42, 'Scope 3': 1.00 },
  { month: 'Sep-25', 'Scope 1': 0.28, 'Scope 2': 0.39, 'Scope 3': 0.95 },
  { month: 'Oct-25', 'Scope 1': 0.27, 'Scope 2': 0.37, 'Scope 3': 0.91 },
  { month: 'Nov-25', 'Scope 1': 0.26, 'Scope 2': 0.33, 'Scope 3': 0.85 },
  { month: 'Dec-25', 'Scope 1': 0.25, 'Scope 2': 0.32, 'Scope 3': 0.83 }
]

export const dummyDataStackedEmissions = [
  { month: 'Jan-25', Total: 1.58 },
  { month: 'Feb-25', Total: 1.52 },
  { month: 'Mar-25', Total: 1.63 },
  { month: 'Apr-25', Total: 1.44 },
  { month: 'May-25', Total: 1.69 },
  { month: 'Jun-25', Total: 1.76 },
  { month: 'Jul-25', Total: 1.83 },
  { month: 'Aug-25', Total: 1.72 },
  { month: 'Sep-25', Total: 1.62 },
  { month: 'Oct-25', Total: 1.55 },
  { month: 'Nov-25', Total: 1.44 },
  { month: 'Dec-25', Total: 1.40 }
]


export const dummyDataDeck: any = [
  {
    id: 1,
    customerName: 'Test Customer 1',
    energySupplierName: 'Octopus Energy',
    gasSupplierName: 'British Gas',
    locations: [
      {
        locationName: 'Head Office',
        locationPostcode: 'WC34 2RT',
        energyConsumption: [
          { month: 'January', consumption: 212, units: 'kWh', emissionAmount: 212 * 0.20705, id: 1 },
          { month: 'Feb', consumption: 203, units: 'kWh', emissionAmount: 203 * 0.20705, id: 2 },
          { month: 'March', consumption: 195, units: 'kWh', emissionAmount: 195 * 0.20705, id: 3 },
          { month: 'April', consumption: 172, units: 'kWh', emissionAmount: 172 * 0.20705, id: 4 },
          { month: 'May', consumption: 160, units: 'kWh', emissionAmount: 160 * 0.20705, id: 5 },
          { month: 'June', consumption: 158, units: 'kWh', emissionAmount: 158 * 0.20705, id: 6 },
          { month: 'July', consumption: 155, units: 'kWh', emissionAmount: 155 * 0.20705, id: 7 },
          { month: 'August', consumption: 152, units: 'kWh', emissionAmount: 152 * 0.20705, id: 8 },
          { month: 'September', consumption: 159, units: 'kWh', emissionAmount: 159 * 0.20705, id: 9 },
          { month: 'October', consumption: 168, units: 'kWh', emissionAmount: 168 * 0.20705, id: 10 },
          { month: 'November', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 11 },
          { month: 'December', consumption: 197, units: 'kWh', emissionAmount: 197 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 698, units: 'kWh', emissionAmount: 698 * 0.20264, id: 1 },
          { month: 'Feb', consumption: 672, units: 'kWh', emissionAmount: 672 * 0.20264, id: 2 },
          { month: 'March', consumption: 661, units: 'kWh', emissionAmount: 661 * 0.20264, id: 3 },
          { month: 'April', consumption: 644, units: 'kWh', emissionAmount: 644 * 0.20264, id: 4 },
          { month: 'May', consumption: 621, units: 'kWh', emissionAmount: 621 * 0.20264, id: 5 },
          { month: 'June', consumption: 619, units: 'kWh', emissionAmount: 619 * 0.20264, id: 6 },
          { month: 'July', consumption: 604, units: 'kWh', emissionAmount: 604 * 0.20264, id: 7 },
          { month: 'August', consumption: 587, units: 'kWh', emissionAmount: 587 * 0.20264, id: 8 },
          { month: 'September', consumption: 599, units: 'kWh', emissionAmount: 599 * 0.20264, id: 9 },
          { month: 'October', consumption: 622, units: 'kWh', emissionAmount: 622 * 0.20264, id: 10 },
          { month: 'November', consumption: 667, units: 'kWh', emissionAmount: 667 * 0.20264, id: 11 },
          { month: 'December', consumption: 687, units: 'kWh', emissionAmount: 687 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'London City',
        locationPostcode: 'EC2R 8DN',
        energyConsumption: [
          { month: 'January', consumption: 212, units: 'kWh', emissionAmount: 212 * 0.20705, id: 1 },
          { month: 'Feb', consumption: 203, units: 'kWh', emissionAmount: 203 * 0.20705, id: 2 },
          { month: 'March', consumption: 195, units: 'kWh', emissionAmount: 195 * 0.20705, id: 3 },
          { month: 'April', consumption: 172, units: 'kWh', emissionAmount: 172 * 0.20705, id: 4 },
          { month: 'May', consumption: 160, units: 'kWh', emissionAmount: 160 * 0.20705, id: 5 },
          { month: 'June', consumption: 158, units: 'kWh', emissionAmount: 158 * 0.20705, id: 6 },
          { month: 'July', consumption: 155, units: 'kWh', emissionAmount: 155 * 0.20705, id: 7 },
          { month: 'August', consumption: 152, units: 'kWh', emissionAmount: 152 * 0.20705, id: 8 },
          { month: 'September', consumption: 159, units: 'kWh', emissionAmount: 159 * 0.20705, id: 9 },
          { month: 'October', consumption: 168, units: 'kWh', emissionAmount: 168 * 0.20705, id: 10 },
          { month: 'November', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 11 },
          { month: 'December', consumption: 197, units: 'kWh', emissionAmount: 197 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 704, units: 'kWh', emissionAmount: 704 * 0.20264, id: 1 },
          { month: 'Feb', consumption: 678, units: 'kWh', emissionAmount: 678 * 0.20264, id: 2 },
          { month: 'March', consumption: 661, units: 'kWh', emissionAmount: 661 * 0.20264, id: 3 },
          { month: 'April', consumption: 642, units: 'kWh', emissionAmount: 642 * 0.20264, id: 4 },
          { month: 'May', consumption: 618, units: 'kWh', emissionAmount: 618 * 0.20264, id: 5 },
          { month: 'June', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 6 },
          { month: 'July', consumption: 604, units: 'kWh', emissionAmount: 604 * 0.20264, id: 7 },
          { month: 'August', consumption: 592, units: 'kWh', emissionAmount: 592 * 0.20264, id: 8 },
          { month: 'September', consumption: 602, units: 'kWh', emissionAmount: 602 * 0.20264, id: 9 },
          { month: 'October', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 10 },
          { month: 'November', consumption: 667, units: 'kWh', emissionAmount: 667 * 0.20264, id: 11 },
          { month: 'December', consumption: 683, units: 'kWh', emissionAmount: 683 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'Leeds City',
        locationPostcode: 'LS1 4DY',
        energyConsumption: [
          { month: 'January', consumption: 223, units: 'kWh', emissionAmount: 223 * 0.20705, id: 1 },
          { month: 'Feb', consumption: 209, units: 'kWh', emissionAmount: 209 * 0.20705, id: 2 },
          { month: 'March', consumption: 193, units: 'kWh', emissionAmount: 193 * 0.20705, id: 3 },
          { month: 'April', consumption: 163, units: 'kWh', emissionAmount: 163 * 0.20705, id: 4 },
          { month: 'May', consumption: 158, units: 'kWh', emissionAmount: 158 * 0.20705, id: 5 },
          { month: 'June', consumption: 155, units: 'kWh', emissionAmount: 155 * 0.20705, id: 6 },
          { month: 'July', consumption: 153, units: 'kWh', emissionAmount: 153 * 0.20705, id: 7 },
          { month: 'August', consumption: 149, units: 'kWh', emissionAmount: 149 * 0.20705, id: 8 },
          { month: 'September', consumption: 161, units: 'kWh', emissionAmount: 161 * 0.20705, id: 9 },
          { month: 'October', consumption: 171, units: 'kWh', emissionAmount: 171 * 0.20705, id: 10 },
          { month: 'November', consumption: 184, units: 'kWh', emissionAmount: 184 * 0.20705, id: 11 },
          { month: 'December', consumption: 201, units: 'kWh', emissionAmount: 201 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 704, units: 'kWh', emissionAmount: 704 * 0.20264, id: 1 },
          { month: 'Feb', consumption: 678, units: 'kWh', emissionAmount: 678 * 0.20264, id: 2 },
          { month: 'March', consumption: 661, units: 'kWh', emissionAmount: 661 * 0.20264, id: 3 },
          { month: 'April', consumption: 642, units: 'kWh', emissionAmount: 642 * 0.20264, id: 4 },
          { month: 'May', consumption: 618, units: 'kWh', emissionAmount: 618 * 0.20264, id: 5 },
          { month: 'June', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 6 },
          { month: 'July', consumption: 604, units: 'kWh', emissionAmount: 604 * 0.20264, id: 7 },
          { month: 'August', consumption: 592, units: 'kWh', emissionAmount: 592 * 0.20264, id: 8 },
          { month: 'September', consumption: 602, units: 'kWh', emissionAmount: 602 * 0.20264, id: 9 },
          { month: 'October', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 10 },
          { month: 'November', consumption: 667, units: 'kWh', emissionAmount: 667 * 0.20264, id: 11 },
          { month: 'December', consumption: 683, units: 'kWh', emissionAmount: 683 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'Manchester City',
        locationPostcode: 'M4 5AD',
        energyConsumption: [
          { month: 'January', consumption: 223, units: 'kWh', emissionAmount: 223 * 0.20705, id: 1 },
          { month: 'Feb', consumption: 209, units: 'kWh', emissionAmount: 209 * 0.20705, id: 2 },
          { month: 'March', consumption: 193, units: 'kWh', emissionAmount: 193 * 0.20705, id: 3 },
          { month: 'April', consumption: 163, units: 'kWh', emissionAmount: 163 * 0.20705, id: 4 },
          { month: 'May', consumption: 158, units: 'kWh', emissionAmount: 158 * 0.20705, id: 5 },
          { month: 'June', consumption: 155, units: 'kWh', emissionAmount: 155 * 0.20705, id: 6 },
          { month: 'July', consumption: 153, units: 'kWh', emissionAmount: 153 * 0.20705, id: 7 },
          { month: 'August', consumption: 149, units: 'kWh', emissionAmount: 149 * 0.20705, id: 8 },
          { month: 'September', consumption: 161, units: 'kWh', emissionAmount: 161 * 0.20705, id: 9 },
          { month: 'October', consumption: 171, units: 'kWh', emissionAmount: 171 * 0.20705, id: 10 },
          { month: 'November', consumption: 184, units: 'kWh', emissionAmount: 184 * 0.20705, id: 11 },
          { month: 'December', consumption: 201, units: 'kWh', emissionAmount: 201 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 715, units: 'kWh', emissionAmount: 715 * 0.20264, id: 1 },
          { month: 'Feb', consumption: 678, units: 'kWh', emissionAmount: 678 * 0.20264, id: 2 },
          { month: 'March', consumption: 666, units: 'kWh', emissionAmount: 666 * 0.20264, id: 3 },
          { month: 'April', consumption: 644, units: 'kWh', emissionAmount: 644 * 0.20264, id: 4 },
          { month: 'May', consumption: 618, units: 'kWh', emissionAmount: 618 * 0.20264, id: 5 },
          { month: 'June', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 6 },
          { month: 'July', consumption: 604, units: 'kWh', emissionAmount: 604 * 0.20264, id: 7 },
          { month: 'August', consumption: 592, units: 'kWh', emissionAmount: 592 * 0.20264, id: 8 },
          { month: 'September', consumption: 602, units: 'kWh', emissionAmount: 602 * 0.20264, id: 9 },
          { month: 'October', consumption: 617, units: 'kWh', emissionAmount: 617 * 0.20264, id: 10 },
          { month: 'November', consumption: 667, units: 'kWh', emissionAmount: 667 * 0.20264, id: 11 },
          { month: 'December', consumption: 683, units: 'kWh', emissionAmount: 683 * 0.20264, id: 12 }
        ]
      }
    ]
  },
  {
    id: 2,
    customerName: 'Test Customer 2',
    energySupplierName: 'EDF Energy',
    gasSupplierName: 'E.ON',
    locations: [
      {
        locationName: 'Bath Office',
        locationPostcode: 'BA3 RE2',
        energyConsumption: [
          { month: 'January', consumption: 240, units: 'kWh', emissionAmount: 240 * 0.20705, id: 1 },
          { month: 'February', consumption: 230, units: 'kWh', emissionAmount: 230 * 0.20705, id: 2 },
          { month: 'March', consumption: 220, units: 'kWh', emissionAmount: 220 * 0.20705, id: 3 },
          { month: 'April', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 4 },
          { month: 'May', consumption: 190, units: 'kWh', emissionAmount: 190 * 0.20705, id: 5 },
          { month: 'June', consumption: 180, units: 'kWh', emissionAmount: 180 * 0.20705, id: 6 },
          { month: 'July', consumption: 175, units: 'kWh', emissionAmount: 175 * 0.20705, id: 7 },
          { month: 'August', consumption: 170, units: 'kWh', emissionAmount: 170 * 0.20705, id: 8 },
          { month: 'September', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 9 },
          { month: 'October', consumption: 195, units: 'kWh', emissionAmount: 195 * 0.20705, id: 10 },
          { month: 'November', consumption: 210, units: 'kWh', emissionAmount: 210 * 0.20705, id: 11 },
          { month: 'December', consumption: 230, units: 'kWh', emissionAmount: 230 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 740, units: 'kWh', emissionAmount: 740 * 0.20264, id: 1 },
          { month: 'February', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 2 },
          { month: 'March', consumption: 690, units: 'kWh', emissionAmount: 690 * 0.20264, id: 3 },
          { month: 'April', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 4 },
          { month: 'May', consumption: 650, units: 'kWh', emissionAmount: 650 * 0.20264, id: 5 },
          { month: 'June', consumption: 630, units: 'kWh', emissionAmount: 630 * 0.20264, id: 6 },
          { month: 'July', consumption: 610, units: 'kWh', emissionAmount: 610 * 0.20264, id: 7 },
          { month: 'August', consumption: 600, units: 'kWh', emissionAmount: 600 * 0.20264, id: 8 },
          { month: 'September', consumption: 620, units: 'kWh', emissionAmount: 620 * 0.20264, id: 9 },
          { month: 'October', consumption: 650, units: 'kWh', emissionAmount: 650 * 0.20264, id: 10 },
          { month: 'November', consumption: 700, units: 'kWh', emissionAmount: 700 * 0.20264, id: 11 },
          { month: 'December', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'Birmingham City',
        locationPostcode: 'B2 4A1',
        energyConsumption: [
          { month: 'January', consumption: 210, units: 'kWh', emissionAmount: 210 * 0.20705, id: 13 },
          { month: 'February', consumption: 205, units: 'kWh', emissionAmount: 205 * 0.20705, id: 14 },
          { month: 'March', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 15 },
          { month: 'April', consumption: 190, units: 'kWh', emissionAmount: 190 * 0.20705, id: 16 },
          { month: 'May', consumption: 180, units: 'kWh', emissionAmount: 180 * 0.20705, id: 17 },
          { month: 'June', consumption: 170, units: 'kWh', emissionAmount: 170 * 0.20705, id: 18 },
          { month: 'July', consumption: 165, units: 'kWh', emissionAmount: 165 * 0.20705, id: 19 },
          { month: 'August', consumption: 160, units: 'kWh', emissionAmount: 160 * 0.20705, id: 20 },
          { month: 'September', consumption: 175, units: 'kWh', emissionAmount: 175 * 0.20705, id: 21 },
          { month: 'October', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 22 },
          { month: 'November', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 23 },
          { month: 'December', consumption: 215, units: 'kWh', emissionAmount: 215 * 0.20705, id: 24 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 700, units: 'kWh', emissionAmount: 700 * 0.20264, id: 13 },
          { month: 'February', consumption: 690, units: 'kWh', emissionAmount: 690 * 0.20264, id: 14 },
          { month: 'March', consumption: 680, units: 'kWh', emissionAmount: 680 * 0.20264, id: 15 },
          { month: 'April', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 16 },
          { month: 'May', consumption: 660, units: 'kWh', emissionAmount: 660 * 0.20264, id: 17 },
          { month: 'June', consumption: 650, units: 'kWh', emissionAmount: 650 * 0.20264, id: 18 },
          { month: 'July', consumption: 640, units: 'kWh', emissionAmount: 640 * 0.20264, id: 19 },
          { month: 'August', consumption: 630, units: 'kWh', emissionAmount: 630 * 0.20264, id: 20 },
          { month: 'September', consumption: 640, units: 'kWh', emissionAmount: 640 * 0.20264, id: 21 },
          { month: 'October', consumption: 660, units: 'kWh', emissionAmount: 660 * 0.20264, id: 22 },
          { month: 'November', consumption: 680, units: 'kWh', emissionAmount: 680 * 0.20264, id: 23 },
          { month: 'December', consumption: 700, units: 'kWh', emissionAmount: 700 * 0.20264, id: 24 }
        ]
      },
      {
        locationName: 'Glasgow City',
        locationPostcode: 'G2 1BA',
        energyConsumption: [
          { month: 'January', consumption: 220, units: 'kWh', emissionAmount: 220 * 0.20705, id: 25 },
          { month: 'February', consumption: 215, units: 'kWh', emissionAmount: 215 * 0.20705, id: 26 },
          { month: 'March', consumption: 210, units: 'kWh', emissionAmount: 210 * 0.20705, id: 27 },
          { month: 'April', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 28 },
          { month: 'May', consumption: 190, units: 'kWh', emissionAmount: 190 * 0.20705, id: 29 },
          { month: 'June', consumption: 180, units: 'kWh', emissionAmount: 180 * 0.20705, id: 30 },
          { month: 'July', consumption: 170, units: 'kWh', emissionAmount: 170 * 0.20705, id: 31 },
          { month: 'August', consumption: 165, units: 'kWh', emissionAmount: 165 * 0.20705, id: 32 },
          { month: 'September', consumption: 180, units: 'kWh', emissionAmount: 180 * 0.20705, id: 33 },
          { month: 'October', consumption: 190, units: 'kWh', emissionAmount: 190 * 0.20705, id: 34 },
          { month: 'November', consumption: 210, units: 'kWh', emissionAmount: 210 * 0.20705, id: 35 },
          { month: 'December', consumption: 230, units: 'kWh', emissionAmount: 230 * 0.20705, id: 36 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 25 },
          { month: 'February', consumption: 710, units: 'kWh', emissionAmount: 710 * 0.20264, id: 26 },
          { month: 'March', consumption: 700, units: 'kWh', emissionAmount: 700 * 0.20264, id: 27 },
          { month: 'April', consumption: 690, units: 'kWh', emissionAmount: 690 * 0.20264, id: 28 },
          { month: 'May', consumption: 680, units: 'kWh', emissionAmount: 680 * 0.20264, id: 29 },
          { month: 'June', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 30 },
          { month: 'July', consumption: 660, units: 'kWh', emissionAmount: 660 * 0.20264, id: 31 },
          { month: 'August', consumption: 650, units: 'kWh', emissionAmount: 650 * 0.20264, id: 32 },
          { month: 'September', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 33 },
          { month: 'October', consumption: 690, units: 'kWh', emissionAmount: 690 * 0.20264, id: 34 },
          { month: 'November', consumption: 710, units: 'kWh', emissionAmount: 710 * 0.20264, id: 35 },
          { month: 'December', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 36 }
        ]
      }
    ]
  },
  {
    id: 3,
    customerName: 'Test Customer 3',
    energySupplierName: 'Bulb Energy',
    gasSupplierName: 'Scottish Gas',
    locations: [
      {
        locationName: 'Bristol Office',
        locationPostcode: 'BS1 5DQ',
        energyConsumption: [
          { month: 'January', consumption: 234, units: 'kWh', emissionAmount: 234 * 0.20705, id: 1 },
          { month: 'February', consumption: 218, units: 'kWh', emissionAmount: 218 * 0.20705, id: 2 },
          { month: 'March', consumption: 210, units: 'kWh', emissionAmount: 210 * 0.20705, id: 3 },
          { month: 'April', consumption: 192, units: 'kWh', emissionAmount: 192 * 0.20705, id: 4 },
          { month: 'May', consumption: 180, units: 'kWh', emissionAmount: 180 * 0.20705, id: 5 },
          { month: 'June', consumption: 175, units: 'kWh', emissionAmount: 175 * 0.20705, id: 6 },
          { month: 'July', consumption: 168, units: 'kWh', emissionAmount: 168 * 0.20705, id: 7 },
          { month: 'August', consumption: 160, units: 'kWh', emissionAmount: 160 * 0.20705, id: 8 },
          { month: 'September', consumption: 172, units: 'kWh', emissionAmount: 172 * 0.20705, id: 9 },
          { month: 'October', consumption: 184, units: 'kWh', emissionAmount: 184 * 0.20705, id: 10 },
          { month: 'November', consumption: 192, units: 'kWh', emissionAmount: 192 * 0.20705, id: 11 },
          { month: 'December', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 750, units: 'kWh', emissionAmount: 750 * 0.20264, id: 1 },
          { month: 'February', consumption: 732, units: 'kWh', emissionAmount: 732 * 0.20264, id: 2 },
          { month: 'March', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 3 },
          { month: 'April', consumption: 698, units: 'kWh', emissionAmount: 698 * 0.20264, id: 4 },
          { month: 'May', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 5 },
          { month: 'June', consumption: 655, units: 'kWh', emissionAmount: 655 * 0.20264, id: 6 },
          { month: 'July', consumption: 648, units: 'kWh', emissionAmount: 648 * 0.20264, id: 7 },
          { month: 'August', consumption: 635, units: 'kWh', emissionAmount: 635 * 0.20264, id: 8 },
          { month: 'September', consumption: 660, units: 'kWh', emissionAmount: 660 * 0.20264, id: 9 },
          { month: 'October', consumption: 680, units: 'kWh', emissionAmount: 680 * 0.20264, id: 10 },
          { month: 'November', consumption: 710, units: 'kWh', emissionAmount: 710 * 0.20264, id: 11 },
          { month: 'December', consumption: 725, units: 'kWh', emissionAmount: 725 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'Oxford Branch',
        locationPostcode: 'OX1 3HW',
        energyConsumption: [
          { month: 'January', consumption: 245, units: 'kWh', emissionAmount: 245 * 0.20705, id: 1 },
          { month: 'February', consumption: 230, units: 'kWh', emissionAmount: 230 * 0.20705, id: 2 },
          { month: 'March', consumption: 215, units: 'kWh', emissionAmount: 215 * 0.20705, id: 3 },
          { month: 'April', consumption: 190, units: 'kWh', emissionAmount: 190 * 0.20705, id: 4 },
          { month: 'May', consumption: 182, units: 'kWh', emissionAmount: 182 * 0.20705, id: 5 },
          { month: 'June', consumption: 178, units: 'kWh', emissionAmount: 178 * 0.20705, id: 6 },
          { month: 'July', consumption: 172, units: 'kWh', emissionAmount: 172 * 0.20705, id: 7 },
          { month: 'August', consumption: 160, units: 'kWh', emissionAmount: 160 * 0.20705, id: 8 },
          { month: 'September', consumption: 175, units: 'kWh', emissionAmount: 175 * 0.20705, id: 9 },
          { month: 'October', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 10 },
          { month: 'November', consumption: 198, units: 'kWh', emissionAmount: 198 * 0.20705, id: 11 },
          { month: 'December', consumption: 205, units: 'kWh', emissionAmount: 205 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 710, units: 'kWh', emissionAmount: 710 * 0.20264, id: 1 },
          { month: 'February', consumption: 685, units: 'kWh', emissionAmount: 685 * 0.20264, id: 2 },
          { month: 'March', consumption: 670, units: 'kWh', emissionAmount: 670 * 0.20264, id: 3 },
          { month: 'April', consumption: 640, units: 'kWh', emissionAmount: 640 * 0.20264, id: 4 },
          { month: 'May', consumption: 620, units: 'kWh', emissionAmount: 620 * 0.20264, id: 5 },
          { month: 'June', consumption: 615, units: 'kWh', emissionAmount: 615 * 0.20264, id: 6 },
          { month: 'July', consumption: 605, units: 'kWh', emissionAmount: 605 * 0.20264, id: 7 },
          { month: 'August', consumption: 590, units: 'kWh', emissionAmount: 590 * 0.20264, id: 8 },
          { month: 'September', consumption: 612, units: 'kWh', emissionAmount: 612 * 0.20264, id: 9 },
          { month: 'October', consumption: 625, units: 'kWh', emissionAmount: 625 * 0.20264, id: 10 },
          { month: 'November', consumption: 648, units: 'kWh', emissionAmount: 648 * 0.20264, id: 11 },
          { month: 'December', consumption: 665, units: 'kWh', emissionAmount: 665 * 0.20264, id: 12 }
        ]
      },
      {
        locationName: 'Liverpool Centre',
        locationPostcode: 'L1 3DZ',
        energyConsumption: [
          { month: 'January', consumption: 260, units: 'kWh', emissionAmount: 260 * 0.20705, id: 1 },
          { month: 'February', consumption: 245, units: 'kWh', emissionAmount: 245 * 0.20705, id: 2 },
          { month: 'March', consumption: 230, units: 'kWh', emissionAmount: 230 * 0.20705, id: 3 },
          { month: 'April', consumption: 215, units: 'kWh', emissionAmount: 215 * 0.20705, id: 4 },
          { month: 'May', consumption: 198, units: 'kWh', emissionAmount: 198 * 0.20705, id: 5 },
          { month: 'June', consumption: 192, units: 'kWh', emissionAmount: 192 * 0.20705, id: 6 },
          { month: 'July', consumption: 185, units: 'kWh', emissionAmount: 185 * 0.20705, id: 7 },
          { month: 'August', consumption: 175, units: 'kWh', emissionAmount: 175 * 0.20705, id: 8 },
          { month: 'September', consumption: 188, units: 'kWh', emissionAmount: 188 * 0.20705, id: 9 },
          { month: 'October', consumption: 200, units: 'kWh', emissionAmount: 200 * 0.20705, id: 10 },
          { month: 'November', consumption: 215, units: 'kWh', emissionAmount: 215 * 0.20705, id: 11 },
          { month: 'December', consumption: 225, units: 'kWh', emissionAmount: 225 * 0.20705, id: 12 }
        ],
        gasConsumption: [
          { month: 'January', consumption: 720, units: 'kWh', emissionAmount: 720 * 0.20264, id: 1 },
          { month: 'February', consumption: 695, units: 'kWh', emissionAmount: 695 * 0.20264, id: 2 },
          { month: 'March', consumption: 675, units: 'kWh', emissionAmount: 675 * 0.20264, id: 3 },
          { month: 'April', consumption: 645, units: 'kWh', emissionAmount: 645 * 0.20264, id: 4 },
          { month: 'May', consumption: 628, units: 'kWh', emissionAmount: 628 * 0.20264, id: 5 },
          { month: 'June', consumption: 622, units: 'kWh', emissionAmount: 622 * 0.20264, id: 6 },
          { month: 'July', consumption: 612, units: 'kWh', emissionAmount: 612 * 0.20264, id: 7 },
          { month: 'August', consumption: 600, units: 'kWh', emissionAmount: 600 * 0.20264, id: 8 },
          { month: 'September', consumption: 618, units: 'kWh', emissionAmount: 618 * 0.20264, id: 9 },
          { month: 'October', consumption: 635, units: 'kWh', emissionAmount: 635 * 0.20264, id: 10 },
          { month: 'November', consumption: 660, units: 'kWh', emissionAmount: 660 * 0.20264, id: 11 },
          { month: 'December', consumption: 675, units: 'kWh', emissionAmount: 675 * 0.20264, id: 12 }
        ]
      }
    ]
  }

]

export const dummyDataPreviousBreakdown = {
  total: 22.43,
  perEmployee: 0.72,
  ukTotal: 15.10,
  nonUkTotal: 7.33,
  scope1: 5.18,
  scope2: 4.02,
  scope3: 13.23,
};

export const dummyDataPreviousPeriodLabel = 'FY2023/24';
